export default "__VITE_ASSET__62dea89a__"